import React from "react";
import { TableRow, TableCell } from "@mui/material";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableItem = ({
  id,
  children,
  disableDragArea = [],
  growColumnIndex = null,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
    pointerEvents: isDragging ? "none" : "auto",
    "&:active": {
      cursor: "grabbing",
    },
  };

  const childCount = React.Children.count(children);

  return (
    <TableRow
      ref={setNodeRef}
      hover
      sx={{
        ...style,
        opacity: isDragging ? 0.5 : 1,
        ...(isDragging && {
          "& > .MuiTableCell-root": {
            backgroundColor: "#2E4065",
          },
        }),
      }}
    >
      {React.Children.map(children, (child, index) => {
        const isDragDisabled = disableDragArea.includes(index);
        const isActionsCell =
          disableDragArea.includes(index) ||
          (disableDragArea.length === 0 && index === childCount - 1);
        const cellProps = isDragDisabled ? {} : { ...attributes, ...listeners };

        return (
          <TableCell
            key={index}
            align={isActionsCell ? "right" : undefined}
            sx={{
              cursor: isDragDisabled ? "default" : "grab",
              ...(isActionsCell && {
                whiteSpace: "nowrap",
              }),
              ...(growColumnIndex === index && {
                width: "100%",
              }),
            }}
            {...cellProps}
          >
            {child}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default SortableItem;